import { render } from "./SayfaBasligiAlani.vue?vue&type=template&id=16c298d1&scoped=true"
import script from "./SayfaBasligiAlani.vue?vue&type=script&lang=js"
export * from "./SayfaBasligiAlani.vue?vue&type=script&lang=js"

import "./SayfaBasligiAlani.vue?vue&type=style&index=0&id=16c298d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c298d1"]])

export default __exports__